import {
  ControlSizesMD,
  InlineButton,
} from '@picsart/design-system/components/InlineButton';
import {
  Divider,
  DividerVariants,
} from '@picsart/design-system/components/Divider';
import { IconArrowLeft } from '@picsart/design-system/foundation/icons/IconArrowLeft';
import GenAILogo from '@/components/GenAILogo';
import { Screen } from '@/types';
import useStyles from './styles';

import type { HeaderLeftProps } from './types';

const TaglineContent = () => <>AI-Powered Creation</>;

const HeaderLeft = ({
  screen,
  showBackButton,
  mobileTitle,
  onBack,
}: HeaderLeftProps) => {
  const classes = useStyles();

  return (
    <div className={classes.left}>
      {/* Back button - CSS hides on desktop */}
      {showBackButton && (
        <span className={classes.backButton}>
          <InlineButton
            size={ControlSizesMD}
            centerIcon={IconArrowLeft}
            className={classes.iconButton}
            isWithoutBorder
            isWithoutBackground
            onClick={onBack}
            aria-label="Go back"
            title="Go back"
            dataTestId="header-left-back"
          />
        </span>
      )}
      {/* GenAI Studio Logo - hidden on mobile for non-library screens */}
      <GenAILogo
        className={`${classes.logo} ${
          screen !== Screen.Library ? classes.logoHiddenOnMobile : ''
        }`}
      />
      <div className={classes.titleGroup}>
        {/* Desktop: Always show "GenAI Studio" */}
        <h1 className={`${classes.title} ${classes.titleDesktop}`}>
          GenAI Studio
        </h1>
        {/* Mobile: Show screen-specific title */}
        <h1 className={`${classes.title} ${classes.titleMobile}`}>
          {mobileTitle}
        </h1>

        {/* Desktop: Divider and tagline always visible */}
        <Divider
          variant={DividerVariants.Vertical}
          size={18}
          className={`${classes.titleDivider} ${classes.taglineDesktop}`}
        />
        <span className={`${classes.tagline} ${classes.taglineDesktop}`}>
          <TaglineContent />
        </span>

        {/* Mobile: Divider and tagline only on library screen (hidden on small mobile via CSS) */}
        {screen === Screen.Library && (
          <>
            <Divider
              variant={DividerVariants.Vertical}
              size={18}
              className={`${classes.titleDivider} ${classes.taglineMobile}`}
            />
            <span className={`${classes.tagline} ${classes.taglineMobile}`}>
              <TaglineContent />
            </span>
          </>
        )}
      </div>
    </div>
  );
};

export default HeaderLeft;
